import { useState } from 'react';
import api from '../services/api';

export default function PromoterProfileForm({
  initialData = null,
  onSuccess = () => {},
  mode = 'create',
}) {
  const [formData, setFormData] = useState({
    companyName: initialData?.companyName || '',
    bio: initialData?.bio || '',
    city: initialData?.city || '',
    country: initialData?.country || 'France',
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState(null);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.companyName.trim()) {
      newErrors.companyName = 'Le nom de l\'entreprise est requis';
    } else if (formData.companyName.length > 150) {
      newErrors.companyName = 'Le nom doit faire 150 caractères maximum';
    }

    if (formData.bio.length > 2000) {
      newErrors.bio = 'La bio doit faire 2000 caractères maximum';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    setApiError(null);

    try {
      if (mode === 'create') {
        await api.post('/promoters/profile', formData);
      } else {
        await api.put('/promoters/profile', formData);
      }

      onSuccess();
    } catch (error) {
      setApiError(error.message || 'Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="border th-border p-6 space-y-6 th-bg-surface transition-colors duration-300"
    >
      {/* API Error */}
      {apiError && (
        <div className="border border-status-rejected/30 text-status-rejected px-3 py-2 text-sm font-mono">
          {apiError}
        </div>
      )}

      {/* Company Name */}
      <div>
        <label htmlFor="companyName" className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
          Nom de l'entreprise
        </label>
        <input
          type="text"
          id="companyName"
          name="companyName"
          value={formData.companyName}
          onChange={handleChange}
          placeholder="Nom de votre entreprise ou collectif"
          maxLength="150"
          className="th-input"
        />
        {errors.companyName && (
          <p className="text-status-rejected text-xs mt-1 font-mono">{errors.companyName}</p>
        )}
      </div>

      {/* Bio */}
      <div>
        <label htmlFor="bio" className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
          Bio
        </label>
        <textarea
          id="bio"
          name="bio"
          value={formData.bio}
          onChange={handleChange}
          placeholder="Décrivez votre structure ou collectif (optionnel)"
          maxLength="2000"
          rows="5"
          className="th-input resize-none"
        />
        <p className="th-text-muted text-xs mt-1 font-mono">
          {formData.bio.length} / 2000
        </p>
        {errors.bio && (
          <p className="text-status-rejected text-xs mt-1 font-mono">{errors.bio}</p>
        )}
      </div>

      {/* City */}
      <div>
        <label htmlFor="city" className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
          Ville
        </label>
        <input
          type="text"
          id="city"
          name="city"
          value={formData.city}
          onChange={handleChange}
          placeholder="ex : Paris (optionnel)"
          className="th-input"
        />
      </div>

      {/* Country */}
      <div>
        <label htmlFor="country" className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
          Pays
        </label>
        <input
          type="text"
          id="country"
          name="country"
          value={formData.country}
          onChange={handleChange}
          placeholder="ex : France"
          className="th-input"
        />
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        disabled={isLoading}
        className="w-full th-btn-accent disabled:opacity-50"
      >
        {isLoading
          ? mode === 'create'
            ? 'Création...'
            : 'Enregistrement...'
          : mode === 'create'
            ? 'Créer le profil'
            : 'Enregistrer'}
      </button>
    </form>
  );
}
